import React from 'react';
import { X } from 'lucide-react';
import { ScrollArea } from './ui/scroll-area';

const LegalModal = ({ isOpen, onClose, document, title }) => {
  if (!isOpen || !document) return null;

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/80"
      onClick={onClose}
      data-testid="legal-modal"
    >
      <div 
        className="relative w-full max-w-2xl max-h-[80vh] mx-4 bg-black/95 border border-white/20 rounded-2xl overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-white/10">
          <h2 className="text-lg font-medium text-white pr-8" data-testid="legal-modal-title">
            {title || document.title}
          </h2>
          <button
            onClick={onClose}
            className="absolute right-4 top-4 p-2 rounded-full hover:bg-white/10 transition-colors"
            data-testid="close-legal-modal"
          >
            <X className="w-5 h-5 text-white/70" />
          </button>
        </div>

        {/* Content */}
        <ScrollArea className="h-[60vh] p-6">
          <div className="space-y-6">
            {document.sections.map((section, index) => (
              <div key={index} className="space-y-2">
                <h3 className="text-white font-medium text-sm">
                  {section.title}
                </h3>
                <p className="text-white/70 text-sm leading-relaxed">
                  {section.content}
                </p>
              </div>
            ))}
          </div>
        </ScrollArea>
      </div>
    </div>
  );
};

export default LegalModal;
